/** Simple wait function that executes after a specified time in ms */
const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export default wait;
export { wait };
